import { FormModel } from '../core/form-model.class';
import { CreateSubscriptionDto } from '@shared/common/subscription/create-subscription.dto';
import { OfferType } from '@shared/common/types/offer-type';

export class SubscriptionFormModel extends FormModel(CreateSubscriptionDto) {
  public labels: any = {
    label: 'Libellé',
    agencyId: 'Agence',
    comment: 'Commentaire',
    offerType: 'Type d\'offre',
    config: 'Configuration de la programmation',
  };
  offerType = OfferType.PTI;
}
